import { LocationDto } from 'entities/Location';
import { Actions } from './actions';

import {
  ORDER_ADD_BLLIST_REQUEST,
  ORDER_ADD_BLLIST_SUCCESS,
  ORDER_ADD_BLLIST_ERROR,
  GET_LOCATION_REQUEST,
  GET_LOCATION_SUCCESS,
  GET_LOCATION_ERROR,
  ADD_USER_ID_REQUEST,
  ADD_USER_ID_SUCCESS,
  ADD_USER_ID_ERROR,
  ORDER_CLEAN_ERROR,
  ORDER_GET_USER_ID_SUCCESS,
  ORDER_GET_USER_ID_REQUEST,
  ORDER_GET_USER_ID_ERROR,
} from './constants';

const initialState = {
  loading: false as boolean,
  error: null as Error | null,
  location: null as LocationDto[] | null,

  loadFaceIdAdd: false as boolean,
  fieldFaceIdAdd: '' as string,
  errorFaceIdAdd: null as Error | null,
};

export type TripState = typeof initialState;

export const tripReducer = (state: TripState = initialState, action: Actions) => {
  switch (action.type) {
    case GET_LOCATION_REQUEST: {
      return {
        ...state,
        loading: true,
      };
    }
    case GET_LOCATION_SUCCESS: {
      return {
        ...state,
        loading: false,
        location: action.payload,
      };
    }
    case GET_LOCATION_ERROR: {
      return {
        ...state,
        loading: false,
        location: [],
      };
    }

    case ORDER_ADD_BLLIST_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null,
      };
    }
    case ORDER_ADD_BLLIST_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null,
      };
    }
    case ORDER_ADD_BLLIST_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    }

    case ORDER_GET_USER_ID_REQUEST:
    case ADD_USER_ID_REQUEST: {
      return {
        ...state,
        loadFaceIdAdd: true,
        fieldFaceIdAdd: action.field,
        errorFaceIdAdd: null,
      };
    }
    case ORDER_GET_USER_ID_SUCCESS:
    case ADD_USER_ID_SUCCESS: {
      return {
        ...state,
        loadFaceIdAdd: false,
        errorFaceIdAdd: null,
      };
    }
    case ORDER_GET_USER_ID_ERROR:
    case ADD_USER_ID_ERROR: {
      return {
        ...state,
        loadFaceIdAdd: false,
        errorFaceIdAdd: action.payload,
      };
    }

    case ORDER_CLEAN_ERROR: {
      return {
        ...state,
        loading: false,
        error: null,
        fieldFaceIdAdd: '',
        loadFaceIdAdd: false,
        errorFaceIdAdd: null,
      };
    }
    default: {
      return state;
    }
  }
};
